import { render, staticRenderFns } from "./folder-activity.vue?vue&type=template&id=b5503cbe"
import script from "./folder-activity.vue?vue&type=script&lang=js"
export * from "./folder-activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports